import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import React from "react";
import { Focusable, useDescriptionNode } from "@xo-union/ui-accessibility";
import PropTypes from "prop-types";
export const hasDomainPattern = /^\/\/|^https?:\/\//;
export const isSecureInteralURLPattern = /^https:\/\/(:?[^/]+\.)?theknot\.com(:?$|\/)/; // Trust internal TK url, secure protocol paths OR relative paths

const allowReferrer = url => isSecureInteralURLPattern.test(url) || !hasDomainPattern.test(url);

const Link = props => /*#__PURE__*/React.createElement(Focusable, _extends({
  as: "a"
}, props));
/* eslint-disable jsx-a11y/anchor-has-content */


const descriptionID = 'Union__component-standard-elements__NewWindowAnchor-description';

const NewWindowAnchor = _ref => {
  var _context;

  let {
    rel,
    href,
    'aria-describedby': ariaDescribedBy,
    ...props
  } = _ref;
  const baseRel = allowReferrer(href) ? 'noopener' : 'noopener noreferrer';
  const relValue = rel ? `${baseRel} ${rel}` : baseRel;
  useDescriptionNode(descriptionID, 'Opens in new window');

  const describedBy = _trimInstanceProperty(_context = `${descriptionID} ${ariaDescribedBy || ''}`).call(_context);

  return /*#__PURE__*/React.createElement(Link, _extends({
    target: "_blank",
    rel: relValue,
    href: href
  }, props, {
    "aria-describedby": describedBy
  }));
};

process.env.NODE_ENV !== "production" ? NewWindowAnchor.propTypes = {
  href: PropTypes.string,
  rel: PropTypes.string,
  'aria-describedby': PropTypes.string
} : void 0;

const AssumedTargetAnchor = props => {
  const {
    href
  } = props;

  if (hasDomainPattern.test(href)) {
    return /*#__PURE__*/React.createElement(NewWindowAnchor, _extends({
      href: props.href
    }, props));
  }

  return /*#__PURE__*/React.createElement(Link, props);
};

process.env.NODE_ENV !== "production" ? AssumedTargetAnchor.propTypes = {
  href: PropTypes.string,
  as: PropTypes.elementType
} : void 0;
AssumedTargetAnchor.defaultProps = {
  as: 'a'
};
export { AssumedTargetAnchor, NewWindowAnchor };